(() => {
  const D = window.AVA_DATA;
  if (!D) return;
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const money = n => "$" + n.toLocaleString("en-US");
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  const rich = s => esc(s).replace(/\*([^*]+)\*/g, "<em>$1</em>");
  const IMG = k => (window.EMBEDDED_IMAGES || {})[k];
  const O = D.offer;
  const boostPrice = O.price;
  function wire(targets, shop) {
    if (!Array.isArray(shop) || !shop.length) return;
    targets.forEach((t, i) => {
      const m = shop.find(v => v.title === t.name) || shop[i];
      if (!m) return;
      t.variant = m.id;
      t.available = m.available;
    });
  }
  wire(D.product.finishes, D.product.shopify);
  D.accessories.forEach(a => wire(a.options, a.shopify));
  const state = { finish: D.product.finishes[0].name };

  const ICONS = {
    return: '<path d="M4 9h11a5 5 0 0 1 0 10H9"/><path d="M8 5 4 9l4 4"/>',
    shield: '<path d="M12 3 5 6v6c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V6z"/><path d="m9 12 2 2 4-4"/>',
    truck:  '<path d="M2.5 6.5h11v9.5h-11z"/><path d="M13.5 10h4.2l3.3 3.3V16h-7.5"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    chat:   '<path d="M4 5h16v11H9l-5 4z"/><path d="M8 9.5h8M8 12.5h5"/>',
    card:   '<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18M7 14.5h4"/>',
    box:    '<path d="M3 8 12 4l9 4v9l-9 4-9-4z"/><path d="m3 8 9 4 9-4M12 12v9"/><path d="m7.5 6 9 4"/>',
    clock:  '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    spring: '<path d="M2.5 12H5.5M18.5 12h3"/><ellipse cx="7" cy="12" rx="1.6" ry="4.5"/><ellipse cx="9.5" cy="12" rx="1.6" ry="4.5"/><ellipse cx="12" cy="12" rx="1.6" ry="4.5"/><ellipse cx="14.5" cy="12" rx="1.6" ry="4.5"/><ellipse cx="17" cy="12" rx="1.6" ry="4.5"/>',
    play:   '<path d="M7 4.5v15l13-7.5z"/>',
    ruler:  '<path d="m4 15 11-11 5 5-11 11z"/><path d="m8 11 2 2m1-5 2 2m1-5 2 2"/>',
    wood:   '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="5.2"/><circle cx="12" cy="12" r="1.8"/><path d="M12 3.5v3"/>',
    weight: '<path d="M8.6 9.2a3.4 3.4 0 1 1 6.8 0"/><path d="M6.8 9.2h10.4l1.6 11H5.2z"/><path d="M10 15h4"/>',
    chevL:  '<path d="m14.5 6-6 6 6 6"/>',
    chevR:  '<path d="m9.5 6 6 6-6 6"/>',
    pause:  '<path d="M8.5 5.5v13M15.5 5.5v13"/>',
    soundOff: '<path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="m16 9.5 5 5M21 9.5l-5 5"/>',
    soundOn:  '<path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M15.5 9a4.2 4.2 0 0 1 0 6M18 6.5a7.8 7.8 0 0 1 0 11"/>',
    arrowR: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    close:  '<path d="M6 6l12 12M18 6 6 18"/>',
    google: '<path d="M20 12.2c0-.6-.1-1.2-.2-1.7H12v3.3h4.5a3.9 3.9 0 0 1-1.7 2.5v2.1h2.7c1.6-1.5 2.5-3.6 2.5-6.2z"/><path d="M12 20.5c2.3 0 4.2-.8 5.5-2.1l-2.7-2.1c-.7.5-1.7.8-2.8.8-2.2 0-4-1.5-4.7-3.4H4.5v2.2a8.5 8.5 0 0 0 7.5 4.6z"/><path d="M7.3 13.7a5 5 0 0 1 0-3.4V8.1H4.5a8.5 8.5 0 0 0 0 7.8z"/><path d="M12 6.9c1.2 0 2.3.4 3.2 1.2l2.4-2.4A8.4 8.4 0 0 0 4.5 8.1l2.8 2.2C8 8.4 9.8 6.9 12 6.9z"/>'
  };
  const icon = (k, cls = "icon") => `<svg class="${cls}" viewBox="0 0 24 24" aria-hidden="true">${ICONS[k] || ""}</svg>`;
  const STAR = "m12 3.5 2.6 5.4 5.9.8-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.8z";
  const stars = (n, label) => `<span class="stars" role="img" aria-label="${esc(label || n + " out of 5 stars")}">${
    Array.from({ length: 5 }, (_, i) => `<svg viewBox="0 0 24 24" class="${i < n ? "" : "off"}" aria-hidden="true"><path fill="currentColor" d="${STAR}"/></svg>`).join("")}</span>`;

  const srcset = src => [600, 900, 1400].map(w => `${src}&width=${w} ${w}w`).join(", ");
  function placeholder(p, dark = false) {
    const kind = p.kind || p.ph || "Placeholder";
    return `<div class="ph${dark ? " ph--dark" : ""}" role="img" aria-label="Placeholder. ${esc(kind)}: ${esc(p.text)}">
      <span class="ph__kind">${esc(kind)}</span>
      <span class="ph__text">${esc(p.text)}</span>
      ${p.hold ? `<span class="ph__hold">${esc(p.hold)}</span>` : ""}
    </div>`;
  }
  function imgTag(key, { pos = "50% 50%", sizes = "100vw", eager = false, alt } = {}) {
    const im = D.images[key], emb = IMG(key);
    const src = emb ? `src="${emb}"` : `src="${im.src}&width=900" srcset="${srcset(im.src)}" sizes="${sizes}"`;
    return `<img ${src} alt="${esc(alt ?? im.alt)}" style="object-position:${pos}" ${eager ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async" width="900" height="900">`;
  }
  function media(m, { cls = "", sizes = "(min-width: 900px) 50vw, 100vw", eager = false } = {}) {
    if (!m) return "";
    if (m.ph || m.kind) return `<div class="${cls}">${placeholder(m)}</div>`;
    const im = D.images[m.img];
    const zoom = m.zoom ? ` data-zoom style="--zoom:${m.zoom};--pos:${m.pos || "50% 50%"}"` : "";
    const note = m.hold ? `HOLD: ${m.hold}. ${im.note}` : im.note;
    return `<div class="frame ${cls}" data-note="${esc(note)}"${zoom}>${m.hold ? '<span class="hold-tag">Hold</span>' : ""}${imgTag(m.img, { pos: m.pos, sizes, eager })}</div>`;
  }
  function videoSlot(v, { autoplay = true } = {}) {
    if (!v.src) return null;
    const poster = v.poster || "";
    const pos = v.pos ? ` style="object-position:${v.pos}"` : "";
    if (reduceMotion && poster) return `<img src="${poster}" alt=""${pos}>`;
    return `<video ${autoplay && !reduceMotion ? "autoplay loop muted" : "controls"} playsinline preload="${autoplay ? "auto" : "none"}" ${poster ? `poster="${poster}"` : ""}${pos}
      src="${v.src}" aria-hidden="true"></video>`;
  }
  const affirmText = (lead = "Pay over time") => `${lead} from ${money(D.affirm.from)}/month`;
  const financeText = () => `From ${money(D.affirm.from)}/mo or 0% APR with Shop`;

  const priceNote = O.codeAutoApplies ? esc(O.autoNote) : `with code <strong>${esc(O.code)}</strong>`;
  const logo = (w, h) => `<a class="logo" href="#hero"><img src="${IMG("logo") || D.brand.logo}" alt="${esc(D.brand.name)}" width="${w}" height="${h}"></a>`;

  const track = (label, items, { grid = false, cls = "" } = {}) =>
    `<div class="track${grid ? " track--grid" : ""} ${cls}" data-track tabindex="0" role="region" aria-roledescription="carousel" aria-label="${esc(label)}">${items}</div>
     <div class="dots" data-dots></div>`;

  const blocks = {};

  blocks["top-bar-atc"] = () => `<header class="topbar" data-block="top-bar-atc">
    <div class="wrap topbar__in">
      <p class="topbar__name">${esc(D.product.name)}</p>
      <p class="topbar__price"><s><span class="sr-only">Regular price </span>${money(O.listPrice)}</s> <b><span class="sr-only">Now </span>${money(boostPrice)}</b></p>
      <button class="btn" type="button" data-atc="top-bar">${esc(D.topBar.button)}</button>
    </div>
  </header>`;

  blocks["trust-bar"] = () => `<div class="trustbar" data-block="trust-bar" role="region" aria-label="Store guarantees">
    <ul class="trustbar__list" id="trustbar">${D.trustBar.map((t, i) => `<li class="${i ? "" : "on"}">${icon(t.icon)}${t.affirm ? affirmText() : esc(t.text)}</li>`).join("")}</ul>
  </div>`;

  blocks["hero"] = () => {
    const h = D.hero;
    const vid = videoSlot(h.video);
    const mediaHtml = vid || imgTag(h.hold.img, { pos: h.hold.pos, eager: true, alt: "" });
    return `<section id="hero" class="hero" data-block="hero" aria-labelledby="hero-h">
      <div class="hero__media frame" data-note="${esc(vid ? "Hero video: " + h.video.file : h.placeholder.text + " " + h.placeholder.hold)}" style="border-radius:0">${mediaHtml}</div>
      <div class="hero__scrim"></div>
      ${vid ? "" : `<p class="hero__tag"><b>${esc(h.placeholder.kind)} · Hold</b>Hero video to come. Showing p3 until then.</p>`}
      <div class="wrap hero__in">
        <p class="hero__eyebrow">${esc(h.eyebrow)}</p>
        <h1 id="hero-h">${rich(h.headline)}</h1>
        <div class="hero__buy">
          <button class="btn btn--hero" type="button" data-atc="hero">Buy now · ${money(boostPrice)}</button>
          <s><span class="sr-only">Regular price </span>${money(O.listPrice)}</s>
        </div>
        <ul class="hero__stats" aria-label="Key specs">${h.stats.map(s => `<li><b>${esc(s.big)}</b><span>${esc(s.label)}</span></li>`).join("")}</ul>
      </div>
    </section>`;
  };

  const avgHtml = () => {
    const r = D.reviews;
    const avg = r.average != null ? `<span>${Number(r.average).toFixed(1)}</span>` : `<span class="avg-ph" title="Paste the Google average in DATA.reviews.average">[avg]</span>`;
    return `<span class="rating__score">${stars(5, `Rated ${r.average ?? "[average]"} out of 5 on ${r.platform}`)}${avg}</span>`;
  };

  const avatars = () => `<span class="avatars frame" style="background:none;overflow:visible" data-note="HOLD: crops of product shots until owner photos exist" aria-hidden="true">${
    D.reviews.avatars.map(a => {
      const im = IMG(a.img) || D.images[a.img].src + "&width=400";
      return `<span class="avatar"><img src="${im}" alt="" style="width:${a.z * 100}%;height:${a.z * 100}%;left:calc(50% - ${a.fx * a.z * 100}%);top:calc(50% - ${a.fy * a.z * 100}%)"></span>`;
    }).join("")}</span>`;

  const ratingBadge = () => {
    const r = D.reviews;
    return `<span class="laurel" role="img" aria-label="${r.average ?? "[average]"} out of 5 on ${esc(r.platform)}">${laurel()}<span><b>${r.average != null ? Number(r.average).toFixed(1) : "[avg]"}</b>${stars(5, "")}${esc(r.platform)}</span>${laurel()}</span>`;
  };
  const reviewerName = n => n ? esc(n) : '<span class="avg-ph" title="Add the reviewer’s first name">[First name]</span>';

  blocks["rating-row"] = () => {
    const r = D.reviews, f = r.featured;
    return `<section class="rating" data-block="rating-row" aria-label="Customer rating">
      <div class="wrap">
        <div class="proof">
          <div class="proof__top">
            <span class="proof__who">${avatars()}${stars(f.stars)}</span>
            <figure class="proof__quote">
              <q>${esc(f.text)}</q>
              <figcaption class="proof__by">${reviewerName(f.name)}, ${esc(r.platform)} review</figcaption>
            </figure>
          </div>
          <div class="proof__foot">
            <a class="rv__link" href="${esc(r.url)}" target="_blank" rel="noopener">Read all ${esc(r.platform)} reviews</a>
            ${ratingBadge()}
          </div>
        </div>
      </div>
    </section>`;
  };

  blocks["four-points"] = () => {
    const f = D.fourPoints;
    return `<section class="block band--cream" data-block="four-points" aria-labelledby="fp-h">
      <div class="wrap">
        <div class="head"><h2 id="fp-h">${rich(f.headline)}</h2></div>
        <ul class="points">${f.items.map(p => `<li class="point">
          <span class="point__ic">${icon(p.icon)}</span>
          <h3>${esc(p.title)}</h3>
          <p>${esc(p.text)}</p>
        </li>`).join("")}</ul>
      </div>
    </section>`;
  };

  blocks["setup-video"] = () => {
    const s = D.setupVideo;
    const vid = videoSlot(s.video);
    const vidM = vid && s.videoMobile ? videoSlot(s.videoMobile) : null;
    const body = !vid ? placeholder(s.placeholder, true) + `<span class="vid__play">${icon("play")}</span>`
      : vidM ? `<div class="vid__m">${vidM}</div><div class="vid__d">${vid}</div>` : vid;
    return `<section class="block band--white" data-block="setup-video" aria-labelledby="sv-h">
      <div class="wrap">
        <div class="head"><h2 id="sv-h">${rich(s.headline)}</h2></div>
        <div class="vid${vid ? (vidM ? " vid--split" : " vid--wide") : ""}">
          ${body}
          ${vid ? "" : `<div class="vid__chips">${s.chips.map(c => `<span class="chip">${esc(c)}</span>`).join("")}</div>`}
        </div>
        ${s.fullVideo ? `<p class="vid__more"><a href="${esc(s.fullVideo.url)}" target="_blank" rel="noopener">${esc(s.fullVideo.label)}${icon("arrowR")}<span class="sr-only"> (opens YouTube in a new tab)</span></a></p>` : ""}
      </div>
    </section>`;
  };

  blocks["benefits"] = () => {
    const b = D.benefits;
    const cards = b.items.map((it, i) => `<article class="bcard" role="group" aria-roledescription="slide" aria-label="${i + 1} of ${b.items.length}">
      ${media(it.media, { cls: "bcard__media", sizes: "(min-width: 1000px) 20vw, 78vw" })}
      <div class="bcard__body"><h3>${esc(it.title)}</h3><p>${esc(it.text)}</p></div>
    </article>`).join("");
    return `<section class="block band--tint" data-block="benefits" aria-labelledby="bn-h">
      <div class="wrap" data-carousel>
        <div class="head"><h2 id="bn-h">${rich(b.headline)}</h2></div>
        ${track("Benefits", cards, { grid: true })}
      </div>
    </section>`;
  };

  const dimLines = (lines, W, H, T = 12) => `<div class="dimlines" aria-hidden="true">
    <svg viewBox="0 0 ${W} ${H}" preserveAspectRatio="none">${lines.map(l => {
      const v = l.x1 === l.x2;
      const tick = (x, y) => v ? `<line x1="${x - T}" y1="${y}" x2="${x + T}" y2="${y}"/>` : `<line x1="${x}" y1="${y - T}" x2="${x}" y2="${y + T}"/>`;
      return `<line x1="${l.x1}" y1="${l.y1}" x2="${l.x2}" y2="${l.y2}"/>${tick(l.x1, l.y1)}${tick(l.x2, l.y2)}`;
    }).join("")}</svg>
    ${lines.map(l => `<span style="left:${(l.lx / W * 100).toFixed(2)}%;top:${(l.ly / H * 100).toFixed(2)}%">${esc(l.label)}</span>`).join("")}
  </div>`;

  blocks["dimensions"] = () => {
    const d = D.dimensions;
    return `<section class="block band--cream" data-block="dimensions" aria-labelledby="dm-h">
      <div class="wrap dims">
        ${media(d.media, { cls: "dims__media" }).replace(/<\/div>$/, `${dimLines(d.lines, ...d.size)}</div>`)}
        <div>
          <h2 id="dm-h">${rich(d.headline)}</h2>
          <ul class="dims__nums">${d.nums.map(n => `<li><b>${esc(n.big)}</b><span>${esc(n.label)}</span></li>`).join("")}</ul>
          <p class="dims__support">${esc(d.support)}</p>
        </div>
      </div>
    </section>`;
  };

  const gallerySlides = () => D.miniPdp.gallery.map(k => k === "finish" ? D.product.finishes.find(f => f.name === state.finish).img : k);

  blocks["mini-pdp"] = () => {
    const p = D.miniPdp;
    const keys = gallerySlides();
    const slides = keys.map((k, i) => `<figure class="gal__slide frame" style="border-radius:0" role="group" aria-roledescription="slide" aria-label="Photo ${i + 1} of ${keys.length}" data-note="${esc(D.images[k].note)}" ${i === 0 ? "data-finish-slide" : ""}>${imgTag(k, { sizes: "(min-width: 900px) 50vw, 100vw" })}</figure>`).join("");
    const thumbs = keys.map((k, i) => `<button type="button" data-thumb="${i}" aria-label="Show photo ${i + 1}" ${i === 0 ? 'aria-current="true"' : ""}>${imgTag(k, { sizes: "90px", alt: "" })}</button>`).join("");
    return `<section id="mini-pdp" class="block band--cream" data-block="mini-pdp" aria-labelledby="pdp-h" style="padding-bottom:0">
      <div class="wrap">
        <article class="pdp">
          <div class="pdp__media">
          <div class="pdp__buy">
            <p class="pdp__price"><b>${money(boostPrice)}</b><s><span class="sr-only">Regular price </span>${money(O.listPrice)}</s></p>
            <p class="pdp__code">${priceNote}</p>
            <p class="pdp__fin">${financeText()}</p>
            <button class="btn btn--strong" type="button" data-atc="mini-pdp">${esc(p.cta)}</button>
          </div>
          <div class="gal"${keys.length > 1 ? " data-carousel" : ""}>
            ${keys.length > 1 ? `${track("Product photos", slides)}
            <button class="cbtn cbtn--prev" type="button" data-prev aria-label="Previous photo">${icon("chevL")}</button>
            <button class="cbtn cbtn--next" type="button" data-next aria-label="Next photo">${icon("chevR")}</button>
            <div class="thumbs">${thumbs}</div>` : `<div class="gal__single">${slides.replace(' role="group" aria-roledescription="slide" aria-label="Photo 1 of 1"', "")}</div>`}
          </div>
          </div>
          <div class="pdp__info">
            <div class="pills">${p.pills.map(x => `<span class="pill pill--${x.style}">${esc(x.text)}</span>`).join("")}</div>
            <p class="eyebrow">${esc(p.eyebrow)}</p>
            <h2 id="pdp-h" class="pdp__title">${esc(p.title)}</h2>
            <p class="pdp__desc">${esc(p.description)}</p>
            <fieldset class="finish" id="finish">
              <legend>Finish: <b id="finish-name">${esc(state.finish)}</b></legend>
              <div class="swatches">${D.product.finishes.map((f, i) => `<div class="swatch">
                <input type="radio" name="finish" id="fin-${f.name}" value="${f.name}" ${i === 0 ? "checked" : ""}>
                <label for="fin-${f.name}"><i style="background:${f.swatch}" aria-hidden="true"></i>${esc(f.name)}</label>
              </div>`).join("")}</div>
            </fieldset>
            <dl class="specs">${p.specs.map(s => `<div>${icon(s.icon)}<dt>${esc(s.label)}</dt><dd>${esc(s.value)}</dd></div>`).join("")}</dl>
          </div>
        </article>
      </div>
    </section>`;
  };

  blocks["reassurance-row"] = () => `<section class="band--cream" data-block="reassurance-row" aria-label="Guarantees" style="padding-bottom:var(--sec)">
      <div class="wrap"><ul class="assure">${D.reassurance.map(r => `<li>${icon(r.icon)}${r.affirm ? affirmText() : esc(r.text)}</li>`).join("")}</ul></div>
    </section>`;

  const laurel = () => {
    const LEAF = "M0 0C2.4-2.8 2.4-7 0-9.8C-2.4-7-2.4-2.8 0 0z", R = 22, CX = 33, CY = 30;
    const pt = deg => { const t = deg * Math.PI / 180; return [CX + R * Math.cos(t), CY - R * Math.sin(t), R * Math.sin(t), R * Math.cos(t)]; };
    let leaves = "";
    for (let d = 240; d >= 130; d -= 22) {
      const [x, y, dx, dy] = pt(d), rot = Math.atan2(dx, -dy) * 180 / Math.PI;
      [-38, 38].forEach(o => leaves += `<path d="${LEAF}" transform="translate(${x.toFixed(1)} ${y.toFixed(1)}) rotate(${(rot + o).toFixed(0)})"/>`);
    }
    const [x0, y0] = pt(244), [x1, y1] = pt(124);
    return `<svg viewBox="0 0 36 60" aria-hidden="true"><path d="M${x0.toFixed(1)} ${y0.toFixed(1)}A${R} ${R} 0 0 1 ${x1.toFixed(1)} ${y1.toFixed(1)}" fill="none" stroke="currentColor" stroke-width="1.4"/>${leaves}</svg>`;
  };

  blocks["review-strip"] = () => {
    const r = D.reviews;
    const cards = r.slots.map((s, i) => `<article class="rcard" role="group" aria-roledescription="slide" aria-label="Review ${i + 1} of ${r.slots.length}">
      <div class="rcard__top">${stars(s.stars, `${s.stars} out of 5 stars`)}<span class="badge">${icon("google")}${esc(r.platform)} review</span></div>
      ${s.text ? `<blockquote class="rcard__quote" id="rq-${i}">${esc(s.text)}</blockquote>
        <button type="button" class="rcard__more" aria-controls="rq-${i}" aria-expanded="false" hidden>Read more</button>`
        : `<p class="rcard__quote rcard__quote--ph">Placeholder: paste a real ${esc(r.platform)} review here (${s.stars}-star slot). Add the owner's photo above if they send one.</p>`}
      <p class="rcard__name">${s.text ? reviewerName(s.name) : "[First name]"}</p>
    </article>`).join("");
    return `<section id="reviews" class="block band--tint reviews" data-block="review-strip" aria-labelledby="rv-h">
      <div class="wrap" data-carousel>
        <div class="rv__head">
          <h2 id="rv-h">${rich(r.headline)}</h2>
          <p class="rv__score">${avgHtml()}</p>
        </div>
        ${track(`${r.platform} reviews`, cards, { grid: true })}
      </div>
    </section>`;
  };

  blocks["footer"] = () => `<footer class="footer" data-block="footer">
    <div class="wrap footer__in">
      ${logo(96, 50)}
      <p>Support: ${esc(D.footer.support)}</p>
      <div class="footer__row">
        <span>© 2026 ${esc(D.brand.name)}</span>
      </div>
    </div>
  </footer>`;

  const ORDER = [
    "top-bar-atc", "trust-bar", "hero", "rating-row", "four-points", "setup-video",
    "benefits", "dimensions", "mini-pdp", "reassurance-row", "review-strip", "footer"
  ];
  document.getElementById("page").innerHTML = ORDER.map(k => blocks[k]()).join("");

  function initCarousel(root) {
    const t = root.querySelector("[data-track]");
    const slides = [...t.children];
    const dotsEl = root.querySelector("[data-dots]");
    const prev = root.querySelector("[data-prev]"), next = root.querySelector("[data-next]");
    const thumbs = [...root.querySelectorAll("[data-thumb]")];
    const padL = () => parseFloat(getComputedStyle(t).scrollPaddingLeft) || 0;
    const go = i => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      t.scrollTo({ left: slides[i].offsetLeft - padL(), behavior: reduceMotion ? "auto" : "smooth" });
    };
    if (dotsEl) dotsEl.innerHTML = slides.map((_, i) => `<button type="button" aria-label="Go to item ${i + 1}"></button>`).join("");
    const dots = dotsEl ? [...dotsEl.children] : [];
    dots.forEach((d, i) => d.addEventListener("click", () => go(i)));
    thumbs.forEach(b => b.addEventListener("click", () => go(+b.dataset.thumb)));
    prev && prev.addEventListener("click", () => go(current() - 1));
    next && next.addEventListener("click", () => go(current() + 1));
    function current() {
      const max = t.scrollWidth - t.clientWidth;
      if (max > 0 && t.scrollLeft >= max - 4) return slides.length - 1;
      let best = 0, bd = Infinity;
      slides.forEach((s, i) => { const d = Math.abs(s.offsetLeft - padL() - t.scrollLeft); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function sync() {
      const c = current();
      dots.forEach((d, i) => d.setAttribute("aria-current", i === c));
      thumbs.forEach((b, i) => b.setAttribute("aria-current", i === c));
      if (prev) prev.disabled = c === 0;
      if (next) next.disabled = c === slides.length - 1;
    }
    let raf;
    t.addEventListener("scroll", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    t.addEventListener("keydown", e => {
      if (t.scrollWidth <= t.clientWidth) return;
      if (e.key === "ArrowRight") { e.preventDefault(); go(current() + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); go(current() - 1); }
    });
    sync();
    root._go = go;
  }
  document.querySelectorAll("[data-carousel]").forEach(initCarousel);

  function setFinish(name) {
    if (!D.product.finishes.some(x => x.name === name)) return;
    state.finish = name;
    const label = document.getElementById("finish-name");
    if (label) label.textContent = name;
    const radio = document.getElementById("fin-" + name);
    if (radio) radio.checked = true;
    syncDrawerFinish();
    if (D.miniPdp.gallery[0] !== "finish") return;
    const f = D.product.finishes.find(x => x.name === name);
    const first = document.querySelector("[data-finish-slide]");
    if (!first) return;
    first.innerHTML = imgTag(f.img, { sizes: "(min-width: 900px) 50vw, 100vw" });
    first.dataset.note = D.images[f.img].note;
    const th = document.querySelector('[data-thumb="0"]');
    if (th) th.innerHTML = imgTag(f.img, { sizes: "90px", alt: "" });
    const car = document.querySelector("#mini-pdp [data-carousel]");
    if (car) car._go(0);
  }
  document.getElementById("finish").addEventListener("change", e => setFinish(e.target.value));

  function clampReviews() {
    document.querySelectorAll(".rcard__more").forEach(btn => {
      const q = document.getElementById(btn.getAttribute("aria-controls"));
      if (btn.getAttribute("aria-expanded") === "true") return;
      q.classList.add("is-clamped");
      btn.hidden = q.scrollHeight <= q.clientHeight + 2;
      if (btn.hidden) q.classList.remove("is-clamped");
    });
  }
  document.addEventListener("click", e => {
    const btn = e.target.closest(".rcard__more");
    if (!btn) return;
    const open = btn.getAttribute("aria-expanded") !== "true";
    document.getElementById(btn.getAttribute("aria-controls")).classList.toggle("is-clamped", !open);
    btn.setAttribute("aria-expanded", open);
    btn.textContent = open ? "Show less" : "Read more";
  });
  (document.fonts ? document.fonts.ready : Promise.resolve()).then(clampReviews);
  let clampT; addEventListener("resize", () => { clearTimeout(clampT); clampT = setTimeout(clampReviews, 150); });

  const DR = D.drawer;
  const drawerOpts = () => D.product.finishes.map(f => {
    const on = f.name === state.finish;
    return `<button type="button" class="dopt${on ? " is-on" : ""}" role="radio" aria-checked="${on}" data-dfin="${esc(f.name)}">
      <span class="dopt__mark" aria-hidden="true"></span>
      <span class="dopt__thumb">${imgTag(f.img, { sizes: "64px", alt: "" })}</span>
      <span class="dopt__txt"><b>${esc(D.product.name)}, ${esc(f.name)}</b><span>${esc(f.blurb)}</span></span>
      <span class="dopt__price"><b>${money(boostPrice)}</b><s><span class="sr-only">Regular price </span>${money(O.listPrice)}</s></span>
    </button>`;
  }).join("");

  const ADDONS = [...D.bundles, ...D.accessories];
  const addons = {};
  ADDONS.forEach(a => addons[a.id] = { on: false, option: a.options ? a.options[0].name : null });
  const accOption = a => a.options ? (a.options.find(o => o.name === addons[a.id].option) || a.options[0]) : null;
  const accImg = a => { const o = accOption(a); return (o && o.img) || a.img || DR.thumbFallback; };
  const chipBg = o => o.colors.length === 1
    ? o.colors[0]
    : `conic-gradient(${o.colors.map((c, i, all) => `${c} 0 ${((i + 1) / all.length * 100).toFixed(2)}%`).join(", ")})`;
  const soldOut = t => t && t.available === false;
  const addonCard = a => {
    const sel = accOption(a);
    const sub = sel ? `<span class="acc__colname">${esc(sel.name)}</span>`
      : a.desc ? `<span class="acc__desc">${esc(a.desc)}</span>` : "";
    return `<div class="acc" data-acc="${esc(a.id)}">
      <button type="button" class="acc__row" data-acc-toggle aria-pressed="false">
        <span class="acc__mark" aria-hidden="true"></span>
        <span class="acc__thumb"><img src="${accImg(a)}" alt="" loading="lazy" decoding="async"></span>
        <span class="acc__txt"><b>${esc(a.name)}</b>${sub}</span>
        <span class="acc__price">+${money(a.price)}</span>
      </button>
      ${sel ? `<div class="acc__cols" role="group" aria-label="${esc(a.name)} options">
        ${a.options.map(o => `<button type="button" class="acc__col${o.name === sel.name ? " is-on" : ""}" data-acc-col="${esc(o.name)}" style="--c:${chipBg(o)}" aria-pressed="${o.name === sel.name}" aria-label="${esc(o.name)}"></button>`).join("")}
      </div>` : ""}
    </div>`;
  };
  const cards = list => list.map(addonCard).join("");

  document.body.insertAdjacentHTML("beforeend", `<div class="drawer" id="drawer" hidden>
    <div class="drawer__scrim" data-dclose></div>
    <aside class="drawer__panel" role="dialog" aria-modal="true" aria-labelledby="drawer-h">
      <div class="drawer__head">
        <div class="drawer__bar">
          <button type="button" class="drawer__back" data-dback aria-label="Back">${icon("chevL")}</button>
          <h2 id="drawer-h">${esc(DR.title)}</h2>
          <button type="button" class="drawer__x" data-dclose aria-label="Close">${icon("close")}</button>
        </div>
        <div class="drawer__prog"><i></i></div>
      </div>
      <div class="drawer__body">
        <div class="drawer__track">
          <section class="drawer__step" aria-label="Choose your reformer">
            <div class="dopts" id="dopts" role="radiogroup" aria-label="Finish">${drawerOpts()}</div>
            <p class="drawer__sub">${esc(DR.bundlesTitle)}</p>
            <div class="accs">${cards(D.bundles)}</div>
          </section>
          ${DR.showAccessories ? `<section class="drawer__step" aria-label="Accessories">
            <p class="drawer__sub">${esc(DR.accessoriesTitle)}</p>
            <div class="accs">${cards(D.accessories)}</div>
          </section>` : ""}
        </div>
      </div>
      <div class="drawer__foot">
        <div class="drawer__total"><span>Total</span><b>${money(boostPrice)}</b></div>
        <p class="drawer__code">${priceNote}</p>
        <p class="drawer__fin">${financeText()}</p>
        <button type="button" class="btn btn--strong drawer__cta" data-dgo>${esc(DR.cta)}</button>
        <p class="drawer__ship">${esc(DR.foot)}</p>
      </div>
    </aside>
  </div>`);

  const drawer = document.getElementById("drawer");
  const FOCUSABLE = 'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let drawerLast = null;

  function syncAcc(id) {
    const a = ADDONS.find(x => x.id === id);
    const st = addons[id], sel = accOption(a);
    const card = drawer.querySelector(`[data-acc="${id}"]`);
    card.classList.toggle("is-on", st.on);
    card.querySelector("[data-acc-toggle]").setAttribute("aria-pressed", st.on);
    card.querySelector(".acc__thumb img").src = accImg(a);
    if (!sel) return;
    card.querySelector(".acc__colname").textContent = sel.name;
    card.querySelectorAll("[data-acc-col]").forEach(b => {
      const on = b.dataset.accCol === sel.name;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-pressed", on);
    });
  }
  function syncTotal() {
    const sum = ADDONS.reduce((n, a) => n + (addons[a.id].on ? a.price : 0), boostPrice);
    drawer.querySelector(".drawer__total b").textContent = money(sum);
  }
  const lastStep = DR.showAccessories ? 2 : 1;
  drawer.dataset.steps = lastStep;
  function goStep(n, moveFocus) {
    if (n > lastStep) n = lastStep;
    drawer.dataset.step = n;
    const steps = drawer.querySelectorAll(".drawer__step");
    steps.forEach((el, i) => {
      const off = i + 1 !== n;
      el.toggleAttribute("inert", off);
      el.setAttribute("aria-hidden", off);
    });
    drawer.querySelector(".drawer__cta").textContent = n === lastStep ? DR.ctaFinal : DR.cta;
    drawer.querySelector(".drawer__body").scrollTop = 0;
    if (!moveFocus) return;
    const first = steps[n - 1].querySelector(FOCUSABLE);
    if (first) first.focus({ preventScroll: true });
  }
  function syncDrawerFinish() {
    drawer.querySelectorAll("[data-dfin]").forEach(b => {
      const on = b.dataset.dfin === state.finish;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-checked", on);
    });
  }
  let lockY = 0;
  function lockScroll(on) {
    const body = document.body;
    if (on) {
      lockY = window.scrollY;
      const sb = innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty("--sb", sb + "px");
      body.style.paddingRight = sb + "px";
      body.style.top = -lockY + "px";
      body.classList.add("drawer-open");
      return;
    }
    const root = document.documentElement;
    const prevBehavior = root.style.scrollBehavior;
    body.classList.remove("drawer-open");
    body.style.top = "";
    body.style.paddingRight = "";
    root.style.setProperty("--sb", "0px");
    root.style.scrollBehavior = "auto";
    window.scrollTo(0, lockY);
    root.style.scrollBehavior = prevBehavior;
  }
  function openDrawer() {
    if (!drawer.hidden) return;
    drawerLast = document.activeElement;
    syncDrawerFinish();
    goStep(1, false);
    drawer.hidden = false;
    lockScroll(true);
    requestAnimationFrame(() => drawer.classList.add("is-on"));
    const target = drawer.querySelector(".dopt.is-on") || drawer.querySelector(FOCUSABLE);
    if (target) target.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (drawer.hidden) return;
    drawer.classList.remove("is-on");
    lockScroll(false);
    const hide = () => { drawer.hidden = true; };
    reduceMotion ? hide() : setTimeout(hide, 420);
    if (drawerLast && drawerLast.isConnected) drawerLast.focus({ preventScroll: true });
  }
  function cartItems() {
    const f = D.product.finishes.find(x => x.name === state.finish);
    const items = [];
    if (f && f.variant) items.push({ id: f.variant, quantity: 1 });
    ADDONS.forEach(a => {
      if (!addons[a.id].on) return;
      const sel = accOption(a);
      const v = sel ? sel.variant : a.variant;
      if (v) items.push({ id: v, quantity: 1 });
    });
    return items;
  }
  function note(msg) {
    const t = document.getElementById("toast");
    t.textContent = msg;
    t.classList.add("is-on");
    clearTimeout(note._t);
    note._t = setTimeout(() => t.classList.remove("is-on"), 5000);
  }
  async function post(url, body) {
    const res = await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body || {})
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || "Something went wrong. Please try again.");
    }
    return res.json();
  }
  let checkingOut = false;
  async function checkout() {
    if (checkingOut) return;
    const items = cartItems();
    if (!items.length) { note("This item is not available right now."); return; }
    const btn = drawer.querySelector(".drawer__cta");
    const label = btn.textContent;
    checkingOut = true;
    btn.disabled = true;
    btn.textContent = "One moment\u2026";
    try {
      if (D.cart.clearFirst) await post("/cart/clear.js");
      await post("/cart/add.js", { items });
      const code = D.cart.discountCode;
      window.location.href = code
        ? "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(D.cart.checkoutUrl)
        : D.cart.checkoutUrl;
    } catch (e) {
      checkingOut = false;
      btn.disabled = false;
      btn.textContent = label;
      note(e.message);
    }
  }
  window.openDrawer = openDrawer;
  window.addToCart = openDrawer;

  document.addEventListener("click", e => {
    if (e.target.closest("[data-dclose]")) return closeDrawer();
    const opt = e.target.closest("[data-dfin]");
    if (opt) return setFinish(opt.dataset.dfin);
    const col = e.target.closest("[data-acc-col]");
    if (col) {
      const id = col.closest("[data-acc]").dataset.acc;
      addons[id].option = col.dataset.accCol;
      addons[id].on = true;
      syncAcc(id);
      return syncTotal();
    }
    const add = e.target.closest("[data-acc-toggle]");
    if (add) {
      const id = add.closest("[data-acc]").dataset.acc;
      addons[id].on = !addons[id].on;
      syncAcc(id);
      return syncTotal();
    }
    if (e.target.closest("[data-dback]")) return goStep(1, true);
    if (e.target.closest("[data-dgo]")) return +drawer.dataset.step >= lastStep ? checkout() : goStep(+drawer.dataset.step + 1, true);
    const b = e.target.closest("[data-atc]");
    if (b) openDrawer();
  });
  document.addEventListener("keydown", e => {
    if (drawer.hidden) return;
    if (e.key === "Escape") { e.preventDefault(); return closeDrawer(); }
    const opts = [...drawer.querySelectorAll("[data-dfin]")].filter(x => !x.closest("[inert]"));
    if (["ArrowDown", "ArrowRight", "ArrowUp", "ArrowLeft"].includes(e.key) && opts.includes(document.activeElement)) {
      e.preventDefault();
      const step = (e.key === "ArrowDown" || e.key === "ArrowRight") ? 1 : -1;
      const next = opts[(opts.indexOf(document.activeElement) + step + opts.length) % opts.length];
      setFinish(next.dataset.dfin);
      next.focus();
      return;
    }
    if (e.key !== "Tab") return;
    const f = [...drawer.querySelectorAll(FOCUSABLE)].filter(x => x.offsetParent !== null && !x.closest("[inert]"));
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  const tb = document.getElementById("trustbar"), tbItems = [...tb.children];
  let tbi = 0, tbPaused = false;
  tb.addEventListener("mouseenter", () => tbPaused = true);
  tb.addEventListener("mouseleave", () => tbPaused = false);
  if (!reduceMotion) setInterval(() => {
    if (tbPaused || !matchMedia("(max-width: 899px)").matches) return;
    tbItems[tbi].classList.remove("on");
    tbi = (tbi + 1) % tbItems.length;
    tbItems[tbi].classList.add("on");
  }, 3200);
})();